<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <th class="text-left border-b-2 border-gray w-12"></th>
                    <sortable-header @sort="handleSort" sort-by="credit_card_brand_name" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Brand</sortable-header>
                    <th class="text-left border-b-2 border-gray">Order #</th>
                    <sortable-header @sort="handleSort" sort-by="customer_name" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Customer</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="total" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Total</sortable-header>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in data" :key="item">
                    <td>
                        <span class="brand">
                            <img :src="item.credit_card_brand_image" class="w-8 h-auto" :class="item.credit_card_brand_class" />
                        </span>
                    </td>
                    <td>
                        {{ item.credit_card_brand_name }}
                    </td>
                    <td class="whitespace-nowrap truncate" style="max-width: 150px;" :title="item.order_numbers.join(', ')">
                        {{ item.order_numbers.join(', ') }}
                    </td>
                    <td>{{ item.customer_name }}</td>
                    <td class="text-right">{{ toCurrency(item.total) }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="text-right" colspan="4">Total:</td>
                    <td class="text-right">{{ toCurrency(totalTotal) }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3'
import UseUserAuth from '@/Composables/UseUserAuth';
import SortableHeader from '@/Shared/SortableHeader';

export default {
    components: {
        SortableHeader,
    },

    setup () {
        const { hasFinanceRole } = UseUserAuth(usePage().props.value.user);

        return {
            hasFinanceRole,
        }
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort (sort) {
            this.$emit('sort', sort);
        },
    },

    computed: {
        totalTotal() {
            return this.data.reduce(function(accumulator, currentValue){
                return accumulator + Number(currentValue.total);
            }, 0);
        },
    }

}
</script>

<style scoped>
    .bg-logo {
        background: #efefef;
    }

    .brand {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .brand img {
        max-height: 38px;
    }

    .brand a {
        line-height: 1;
        font-size: 14px;
    }
</style>